import { h, Component } from 'preact';


interface TutorialCompletePageProps {
    onBack: () => void,
    onPlayGame: () => void,
    isInitialRun: boolean,
    onContinue: () => void
}


export class TutorialCompletePage extends Component<TutorialCompletePageProps> {

    render({onBack, onPlayGame, isInitialRun, onContinue }:TutorialCompletePageProps) {
        

        let helpButton = isInitialRun ? <a class="skip-button" onClick={onContinue}>Skip <span class="skip-button-arrow">&#8250;</span></a> : <a class="skip-button">&nbsp;</a>
        let backButton = !isInitialRun ? <a class="back-button" onClick={onBack} >&#8249;</a> : <a class="back-button">&nbsp;</a>

        return (
            <div class="levelcomplete-screen">
                <div class="title-section">
                    { backButton }
                    <span>vowels</span>
                    { helpButton }
                </div>
                <div class="content-section">
                    <div class="content-wrapper grid-complete">
                        <div class="tutorial-menu">
                        <h2>Tutorial Complete!</h2>
                        {isInitialRun 
                            ? <div class="menu-options">
                                <p>Let's try a quick game.</p>
                                <a onClick={onPlayGame}>Continue</a>
                             </div>
                            : <div class="menu-options">
                                <a onClick={onContinue}>Continue</a>
                            </div>
                        }
                        </div>
                    </div>
                </div>
            </div>)
    }
}

